import { call, put, takeLatest } from 'redux-saga/effects';
import * as api from '../../api';
import { loginRequest, loginSuccess, loginFailure, registerRequest, registerSuccess, registerFailure } from '../slices/authSlice';

function* handleLogin(action) {
  try {
    const { data } = yield call(api.loginAPI, action.payload);
    localStorage.setItem('token', data.token);
    localStorage.setItem('userEmail', action.payload.email);
    localStorage.setItem('role', data.role);
    yield put(loginSuccess(data));
  } catch (error) {
    yield put(loginFailure(error.response?.data?.message || "Login Failed"));
  }
}

function* handleRegister(action) {
  try {
    yield call(api.registerAPI, action.payload.data);
    yield put(registerSuccess());
    alert("Registration Successful! Please Login.");
    if (action.payload.navigate) action.payload.navigate('/login');
  } catch (error) {
    yield put(registerFailure(error.response?.data?.message || "Registration Failed"));
  }
}

export default function* authSaga() {
  yield takeLatest(loginRequest.type, handleLogin);
  yield takeLatest(registerRequest.type, handleRegister);
}